<template>
	<div>
		<a-upload :action="url" list-type="picture-card" :multiple="true" :name="data.name" :headers="headers" :data="upInfo"
		 method="post" :beforeUpload="beforeUpload" @preview="handlePreview" :remove="removeFile" @change="handleChange">
			<div v-if="fileList.length < 6">
				<a-icon type="plus" />
				<div class="ant-upload-text">上传图片</div>
			</div>
		</a-upload>
		<a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
			<img alt="example" style="width: 100%" :src="previewImage" />
		</a-modal>
	</div>
</template>
<script>
	import {
		ACCESS_TOKEN
	} from '@/store/mutation-types'
	import storage from 'store'
	import {
		file_del_java
	} from '@/api/activiti'

	function getBase64(file) {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => resolve(reader.result);
			reader.onerror = error => reject(error);
		});
	}
	export default {
		data() {
			return {
				previewVisible: false,
				previewImage: '',
				fileList: [],
				headers: {},
				upInfo: null,
				url: process.env.VUE_APP_API_BASE_URL + "/file/file/upload"
			}
		},
		props: {
			data: {
				type: Object,
				default: true,
			},
		},
		watch: {
			data(val, old) {
				console.log(val, old)
			},
		},
		methods: {
			//删除文件
			removeFile(file) {
				console.log(file.response.data.url[0].path)
				file_del_java({
					types: this.data.type,
					path: file.response.data.url[0].path
				}).then(res => {
					this.$message.success('删除成功')
					this.$emit('reduce')
				})
			},
			// 上传各式限制
			beforeUpload(file) {
				const tok = storage.get(ACCESS_TOKEN)
				this.headers = {
					token: tok,
				}
				this.upInfo = {
					types: this.data.type,
					tempId: this.data.code,
					delFlag: 2,
					path: 'company' + this.$store.state.user.info.deptId + '/',
				}
				var isType = true
				const isLt2M = file.size / 1024 / 1024 < 10
				if (!isLt2M) {
					this.$message.error('上传文件大小不能超过 10MB!')
					this.removeFile(file)
				}
				let fileType = file.type

				if (fileType.indexOf('image') == -1) {
					isType = false
					this.$message.error('只能上传图片文件')
				}
				return isLt2M && isType
			},
			//上传文件
			handleChange(info) {
				if (info.file.status === 'done') {
					if (info.file.response.code != 200) {
						info.fileList.forEach((item, idx) => {
							if (item.uid == info.file.uid) {
								info.fileList.splice(idx, 1)
							}
						})
						this.$message.error(info.file.response.msg)
						return
					}
					this.$message.success('上传成功')
					this.$emit('add')
					// this.fileList.push({
					//   uid: info.file.response.data.url[0].path,
					//   name: info.file.response.data.url[0].fileName,
					//   status: 'done',
					//   url: info.file.response.data.url[0].url,
					// })
				} else if (info.file.status === 'error') {
					this.$message.error('上传失败')
				}
			},
			handleCancel() {
				this.previewVisible = false
			},
			async handlePreview(file) {
				if (!file.url && !file.preview) {
					file.preview = await getBase64(file.originFileObj)
				}
				this.previewImage = file.url || file.preview
				this.previewVisible = true
				console.log(file)
			},
		},
	}
</script>
